import { DownloadResumeResponseDto, Pagination } from '@libs/dto';
import { Resume } from '@libs/models';

import { api } from '../common.api';

export const resumeApi = api.injectEndpoints({
  endpoints: (build) => ({
    resumeCreate: build.mutation<Resume, FormData>({
      query: (body) => ({
        url: '/resume',
        method: 'POST',
        body,
        formData: true,
      }),
      invalidatesTags: ['Resume'],
    }),
    resumeUpdate: build.mutation<Resume, { id: number; formData: FormData }>({
      query: ({ id, formData }) => ({
        url: `/resume/${id}`,
        method: 'PUT',
        body: formData,
        formData: true,
      }),
      invalidatesTags: ['Resume'],
    }),
    resumeIndex: build.query<Pagination<Resume>, { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: '/resume',
        method: 'GET',
        params: { page, limit },
      }),
      providesTags: ['Resume'],
    }),
    resumeSearch: build.query<Pagination<Resume>, { q: string; page?: number; limit?: number }>({
      query: ({ q, page = 1, limit = 10 }) => ({
        url: '/resume/search',
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['Resume'],
    }),
    resumeView: build.query<Resume, number>({
      query: (id) => ({
        url: `/resume/${id}`,
        method: 'GET',
      }),
      providesTags: ['Resume'],
    }),
    resumeDownload: build.query<DownloadResumeResponseDto, number>({
      query: (id) => ({
        url: `/resume/${id}/download`,
        method: 'GET',
        headers: {
          'Accept': 'application/octet-stream, application/pdf',
        }
      }),
    }),
    resumeStream: build.query<Blob, number>({
      query: (id) => ({
        url: `/resume/${id}/stream`,
        method: 'GET',
        responseHandler: async (response: Response) => {
          if (!response.ok) {
            return response.json();
          }
          return response.blob();
        },
      }),
    }),
    resumeDelete: build.mutation<Resume, number>({
      query: (id) => ({
        url: `/resume/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Resume'],
    }),
    resumeSelf: build.query<Resume, void>({
      query: () => ({
        url: '/resume/self',
        method: 'GET',
      }),
      providesTags: ['Resume'],
    }),
  }),
});

export const {
  useResumeCreateMutation,
  useResumeUpdateMutation,
  useResumeIndexQuery,
  useResumeSearchQuery,
  useResumeViewQuery,
  useResumeDeleteMutation,
  useResumeStreamQuery,
  useResumeSelfQuery,
} = resumeApi;